<template>
    <font-awesome-layers class="fa-fw icon-layer" :class="factor">
        <font-awesome-icon icon="circle" :style="circle" />
        <font-awesome-icon v-if="icon" :icon="icon" transform="shrink-6" class="inverse" />
    </font-awesome-layers>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
        },
        color: {
            type: String,
            default: '#9ca5b0',
        },
        size: {
            type: String,
            default: '2x',
        },
    },
    computed: {
        circle() {
            return {
                color: this.color,
            };
        },
        factor() {
            return `fa-${this.size}`;
        },
    },
};
</script>

<style lang="scss">
.icon-layer {
    .inverse {
        color: #ffffff;
    }
}
</style>
